import { render, staticRenderFns } from "./AnnotationBody.vue?vue&type=template&id=0975f9d4"
import script from "./AnnotationBody.vue?vue&type=script&lang=js"
export * from "./AnnotationBody.vue?vue&type=script&lang=js"
import style0 from "./AnnotationBody.vue?vue&type=style&index=0&id=0975f9d4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports